export var MuiButtonGroup = {
    styleOverrides: {
        root: { boxShadow: "none" },
        grouped: function (_a) {
            var theme = _a.theme;
            return ({
                ":not(:last-of-type)": {
                    borderColor: theme.palette.grey[400],
                },
            });
        },
    },
};
